export default __webpack_public_path__ + "static/media/articles-main-md.b5bef4d6.jpg";